import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ExportToPstHelper } from '@common/components/export-to-pst/export-to-pst.helper';
import { FormStructure } from '@common/components/export-to-pst/export-to-pst.model';

@Injectable()
export class ExportToPstFormBuilderService {
  constructor(private fb: FormBuilder) {}

  buildForm(): FormGroup<FormStructure> {
    return this.fb.group(<FormStructure>{
      contacts: this.fb.group({ checked: [true, { nonNullable: true }] }),
      calendar: this.fb.group({ checked: [true, { nonNullable: true }] }),
      mail: this.fb.group({
        checked: [true, { nonNullable: true }],
        filter: this.fb.group({
          from: [ExportToPstHelper.GetOneMonthAgoDate(), { nonNullable: true }],
          to: [new Date(), { nonNullable: true }]
        })
      })
    });
  }

  getDefaultFormValue(): any {
    return {
      contacts: { checked: true },
      calendar: { checked: true },
      mail: {
        checked: true,
        filter: {
          from: ExportToPstHelper.GetOneMonthAgoDate(),
          to: new Date()
        }
      }
    };
  }
}
